// extracted by mini-css-extract-plugin
export default {"hero-container":"Hero_hero-container__KdvS5","img-container":"Hero_img-container__AIP4+","hero-content-container":"Hero_hero-content-container__ZDsY5"};